import React from "react";
import { REACT_APP_CLOUD_FRONT } from "../../../constants";
import { getResetFilters } from "../../../helpers/helperMethods";
import { Filter } from "../../../models/Menu.model";
import styleClasses from "../menu.module.scss";

interface IMenuFilters {
  filterShow: boolean;
  filterCloseHandler: () => void;
  filters: Filter[];
  setFilters: (state: Filter[]) => void;
  setIsFilterApplied: (state: boolean) => void;
  allTags:any;
}

const MenuFilters: React.FC<IMenuFilters> = (props) => {
  const { filters, setFilters, filterShow, filterCloseHandler, allTags, setIsFilterApplied } = props;

  const handleChange = (id: string, status: boolean) => {
    const updatedFilters: Filter[] = filters.map((filter) =>
      filter.id === id ? { ...filter, selected: status } : filter
    );
    setFilters(updatedFilters);
    const isFilterSelected = updatedFilters?.find(filter => filter.selected)
    if (isFilterSelected) setIsFilterApplied(true)
    else setIsFilterApplied(false)
  };

  const handleResetAll = () => {
    const updatedFilters: Filter[] = getResetFilters(filters)
    setFilters(updatedFilters);
    setIsFilterApplied(false)
  };

  const logoSrc = (filter) => {
    if(allTags){
      return `${REACT_APP_CLOUD_FRONT}${filter?.logo}`
    }else{
      return filter.logo
    }
  }

  return (
    <div
      className={`${styleClasses.filter_wrapper} position-relative text-start ${filterShow ? styleClasses.show : styleClasses.hide}`}
    >
      <div className={styleClasses.filter_inner_wrap}>
        <h6 className="mini-heading text-uppercase mb-3">
          Filter By
          <button
            type="button"
            className={`${styleClasses.btn_close} close modal-close-button position-relative blue-hover`}
            onClick={filterCloseHandler}
          >
            Close
          </button>
        </h6>
        <ul className={`${styleClasses.filter_list} list-inline ps-0`}>
          {filters.map((filter) => (
            <li key={filter.id}>
              <div className="form-group theme_check_boxes filter-wrap">
                <input
                  type="checkbox"
                  id={filter.id}
                  checked={filter.selected}
                  data-testid={filter.id}
                  onChange={(e) => handleChange(filter.id, e.target.checked)}
                />
                <label
                  htmlFor={filter.id}
                  className="d-flex align-items-center"
                >
                  <span className="box_wrap"></span>
                  <span className={styleClasses.symbol_icon}>
                    <img src={logoSrc(filter)} className="img-fluid" alt={filter.name} />
                  </span>
                  {filter.name}
                </label>
              </div>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="btn btn-custom border-underline p-0 rounded-0 f-s16 font-Vcf"
          onClick={handleResetAll}
        >
          RESET ALL FILTERS
        </button>
      </div>
    </div>
  );
};

export default MenuFilters;
